import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-66a4d6d2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "cm-ui-txt-rgt" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_tabs = _resolveComponent("el-tabs")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_IPColumn = _resolveComponent("IPColumn")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_ContentAdaptLayout = _resolveComponent("ContentAdaptLayout")!

  return (_openBlock(), _createBlock(_component_ContentAdaptLayout, { class: "cm-ui-pl20 cm-ui-pr20" }, {
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_el_pagination, {
          background: "",
          class: "cm-ui-txt-rgt",
          size: _ctx.queryParams.limit,
          "current-page": _ctx.queryParams.page,
          total: _ctx.viewModel.data.total,
          "page-sizes": [10, 20, 30, 50, 100],
          layout: "total, sizes, prev, pager, next, jumper",
          onSizeChange: _ctx.handlerChangeSizeChange,
          onCurrentChange: _ctx.handlerChangeCurrentChange
        }, null, 8, ["size", "current-page", "total", "onSizeChange", "onCurrentChange"])
      ])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_el_tabs, {
        modelValue: _ctx.tabState.active,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.tabState.active) = $event)),
        onTabClick: _ctx.handleTabSwitch
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_tab_pane, {
            label: _ctx.$t('noticeManage.sending'),
            name: `${_ctx.STATUS.SENDING}`
          }, null, 8, ["label", "name"]),
          _createVNode(_component_el_tab_pane, {
            label: _ctx.$t('noticeManage.successLabel'),
            name: `${_ctx.STATUS.DONE}`
          }, null, 8, ["label", "name"]),
          _createVNode(_component_el_tab_pane, {
            label: _ctx.$t('noticeManage.failed'),
            name: `${_ctx.STATUS.FAIL}`
          }, null, 8, ["label", "name"])
        ]),
        _: 1
      }, 8, ["modelValue", "onTabClick"]),
      _createVNode(_component_el_table, {
        width: "100%",
        height: "100%",
        data: _ctx.viewModel.data.list,
        "empty-text": _ctx.$t('common.noData')
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_table_column, {
            prop: "computer_name",
            label: _ctx.$t('listColumns.computerName')
          }, null, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            prop: "user_mark",
            label: _ctx.$t('listColumns.userMark')
          }, null, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            prop: "group_name",
            label: _ctx.$t('listColumns.groupName')
          }, null, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            prop: "system_ip",
            label: _ctx.$t('noticeManage.ipAddress')
          }, {
            default: _withCtx((scope) => [
              _createVNode(_component_IPColumn, {
                cip: scope.row.client_ip,
                sip: scope.row.system_ip
              }, null, 8, ["cip", "sip"])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            label: _ctx.$t('noticeManage.summaryInfo')
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.message), 1)
            ]),
            _: 1
          }, 8, ["label"])
        ]),
        _: 1
      }, 8, ["data", "empty-text"])
    ]),
    _: 1
  }))
}